import { render } from "./YachtTechdata.vue?vue&type=template&id=373a7906"
import script from "./YachtTechdata.vue?vue&type=script&lang=js"
export * from "./YachtTechdata.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__